






























import { computed, defineComponent, PropType, toRefs, watch } from '@nuxtjs/composition-api'

import useProxyValue from '@/composables/use-proxy-value'
import useDynamicFilterSelect from '@/composables/use-dynamic-filter-select'

import CustomSelectItem from '@/interfaces/CustomSelectItem'

export default defineComponent({
  props: {
    value: {
      type: Array as PropType<CustomSelectItem['value'][]>,
      default: () => [],
    },
    hideTitle: {
      type: Boolean,
      default: false,
    },
    multiRow: {
      type: Boolean,
      default: false,
    },
    // 會顯示的廠牌 id 列表
    list: {
      type: Array as PropType<CustomSelectItem['value'][]>,
      default: () => [],
    },
    chippyCheckbox: {
      type: Boolean,
      default: false,
    },
  },
  setup (props, { emit }) {
    const { proxyValue } = useProxyValue(toRefs(props).value, emit)
    const itemClass = computed(() => {
      if (props.chippyCheckbox) return ''
      return props.multiRow ? 'min-w-1/3' : 'w-full'
    })

    const { value, list } = toRefs(props)
    const { availableList } = useDynamicFilterSelect(
      '/nuxt/brands',
      list,
      value,
    )

    watch(proxyValue, (value) => {
      emit('update', availableList.value.filter(item => value.includes(item.value)))
    }, { immediate: true })

    return {
      proxyValue,
      itemClass,
      availableList,
    }
  },
})
